<template>  
  <div>
    <v-card flat>      
        <div fluid>
          <v-row >
            <v-expansion-panels  v-model="panel" :disabled="disabled" multiple accordion >
              <v-expansion-panel  >
                <v-expansion-panel-header >
                  Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content >
                  <!-- =============Start Search Condition============= -->
                  <v-row align="center" dense >
                    <!-- From Date -->
                    <v-col class="pl-0" cols="6" sm="6"  md="3" lg="2" >                           
                    <DxDateBox  label="From date"  :value="stDate" display-format="yyyy-MM-dd" :acceptCustomValue="false"  @value-changed="e => {stDate = e.value && getStrFormat(e.value)}" dense /> 
                    </v-col>
                    <!-- To date -->
                    <v-col class="pl-0" cols="6" sm="6"  md="3" lg="2">                           
                    <DxDateBox  label="To date"  :value="edDate"  display-format="yyyy-MM-dd" :acceptCustomValue="false"  @value-changed="e => {edDate = e.value && getStrFormat(e.value)}" dense />
                    </v-col> 
                    <!-- Status  -->
                    <v-col  cols="12"  sm="12"  md="3">                    
                    <v-row dense>
                      <v-col  cols="3"  sm="4" md="4">
                        <v-checkbox  v-model="statCd1"  label="Not yet"  color="red" ></v-checkbox>
                      </v-col>
                      <v-col  cols="3"  sm="4"  md="4">
                        <v-checkbox  x-small  v-model="statCd3" label="Receipt" color="indigo"></v-checkbox>
                      </v-col>
                      <v-col cols="3"  sm="4"  md="4">
                        <v-checkbox x-small  v-model="statCd5" label="Reply final" color="green darken-1" ></v-checkbox>
                      </v-col>
                      <v-col  cols="3" sm="4"  md="4">
                        <v-checkbox  x-small  v-model="statCd7"  label="QM return" color="blue accent-4" ></v-checkbox>
                      </v-col>
                      <v-col cols="3"  sm="4"  md="4">
                        <v-checkbox  x-small  v-model="statCd9"  label="Final"  color="amber" ></v-checkbox>
                      </v-col>
                      <v-col  cols="3" sm="4"  md="4">
                        <v-checkbox  x-small  v-model="statCdCan"  label="Withdraw"  color="orange"  ></v-checkbox>
                      </v-col>
                    </v-row>
                    </v-col>
                    <!-- Ship No -->
                    <v-col  class="mt-2"  cols="6"  sm="6"  md="3"  lg="2">
                      <v-select   label="Ship No"  v-model="shipNo"   :items="shipNoList"   return-object   item-value="shipNo"   outlined  dense>
                      </v-select>
                    </v-col>  
                    <!-- Publisher -->
                    <v-col   class="mt-2"  cols="6"  sm="6"  md="3"  lg="2">
                      <v-select  label="Publisher"  v-model="publisherName"   :items="publisherNameList"   return-object   item-value="publisherName"   outlined  dense></v-select>
                    </v-col>   
                    <!-- Department Division -->
                    <v-col  class="mt-2"  cols="6"  sm="6"  md="3"  lg="2">
                      <v-select  label="Division"  v-model="respClsName"  :items="respClsNameList"  return-object   item-value="respClsName"   outlined  dense></v-select>
                    </v-col>                      
                    <!-- Department Section-->
                    <v-col  class="mt-2"  cols="6"  sm="6"  md="3"  lg="2">
                      <v-select  label="Department"  v-model="deptName"  :items="deptNameList"  return-object   item-value="deptName"   outlined  dense></v-select>
                    </v-col> 
                    <!-- QM PIC List-->
                    <v-col  class="mt-2"  cols="6"  sm="6"  md="3"  lg="2">
                      <v-select  label="Employee"  v-model="empName"  :items="empNameList"  return-object   item-value="empName"   outlined  dense></v-select>
                    </v-col>                     
                  </v-row>
                    <!-- ==========End Search Condition================= -->
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
        <!-- Change theme -->
        <v-fab-transition>
          <v-btn v-show="!isMobileDevice"   @click="btnRetrieve"  absolute  top  right  fab>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card>     
    <v-card class="mt-2" > 
      <!-- Search filter --> 
      <v-card-title >
        <v-text-field v-model="search"  append-icon="mdi-magnify"  label="Search"  single-line  hide-details  ></v-text-field>
      </v-card-title>  
      <v-data-table
        :mobile-breakpoint="800"
        :items-per-page="listSize"
        :headers="headers"
        :items="gridMainList"
        fixed-header
        :height="isMobileDevice ? undefined : 600"
        :search="search"
        :sort-by="[]"
        :sort-desc="[false]"
        :dense="true"
        :dark="dark"
        class="mobile-clean-table"
        style="max-width: 100%; overflow-x: auto;"
      >              
        <template v-slot:item="{ item, isMobile }">    
          <mobile-card-item
              v-if="isMobile"
              :item="item"
              :header-value="item.rno"
              :active="selectedRowIndex === item.rno"
              :fields="mobileFields"             
          >
            
            <template v-slot:details>
              <v-btn  
                class="mt-1"              
                x-small
                color="primary"
                :dark="dark"
                @click="showDetailComment(item)"
              >
                Show Detail
              </v-btn>        
            </template>
            <!-- Show Action department -->
            <template v-slot:action1>                     
              <v-btn
                outlined
                x-small
                color="primary"
                :dark="dark"
                @click="showItemAction(item, -1)"
              >
                {{ item.nm1st}}
              </v-btn>          
              <v-chip
                class="ml-1"
                small
                :color="setColorStatus(item.rstatCd)"
                :dark="dark"
                @click="showItemAction(item, -1)"
              >
                {{ item.statNm1}}
              </v-chip>
            </template>

            <template v-slot:action2>                     
              <v-btn 
                outlined           
                x-small
                color="primary"
                :dark="dark"
                @click="showItemAction(item, 1)"
                v-if="item.nm2nd != '' "
              >
                {{ item.nm2nd}}
              </v-btn>
              
              <v-chip
                class="ml-1"
                small
                :color="setColorStatus(item.cstatCd)"
                :dark="dark"
                @click="showItemAction(item, 1)"
                v-if="item.statNm2 != '' "
              >
                {{ item.statNm2}}
              </v-chip>
            </template>

            <template v-slot:subject>
              <a 
                :dark="dark"
                class="text-decoration-underline"
                @click="subjectShow(item)"
                >{{ item.subject }}</a>             
            </template>     
          </mobile-card-item>

          <tr v-else class="custom-pc-row">
            <!-- <td class="v-data-table__divider text-center">{{ item.rno }}</td> -->
            <td class="v-data-table__divider text-center">
              <div class="d-flex justify-space-between">
                    <v-chip
                      class="mt-1 mr-2"   
                      :color="getColor(item.rno)"
                      :dark="dark"
                      small
                      outlined
                    >
                      {{ item.rno }}
                    </v-chip>          
                    <v-btn  
                      class="mt-1"              
                      x-small
                      color="primary"
                      :dark="dark"
                      @click="showDetailComment(item)"
                    >
                      Show Detail
                    </v-btn>        
              </div>
            </td> 
            <td class="v-data-table__divider text-center">{{ item.shipNo }}</td>
            <td class="v-data-table__divider text-center">{{ item.statNm }}</td>
            <td class="v-data-table__divider text-center">{{ item.issueRefDoc }}</td>
            <td class="v-data-table__divider">
              <div class="d-flex justify-space-between">
                 <v-btn
                    outlined
                    x-small
                    color="primary"
                    :dark="dark"
                    @click="showItemAction(item, -1)"
                  >
                    {{ item.nm1st}}
                  </v-btn>          
                  <v-chip
                    class="ml-1"
                    small
                    :color="setColorStatus(item.rstatCd)"
                    :dark="dark"
                    @click="showItemAction(item, -1)"
                  >
                    {{ item.statNm1}}
                  </v-chip>
              </div>
            </td>          
            <td class="v-data-table__divider">
              <div class="d-flex justify-space-between">
                <v-btn 
                  outlined           
                  x-small
                  color="primary"
                  :dark="dark"
                  @click="showItemAction(item, 1)"
                  v-if="item.nm2nd != '' "
                >
                  {{ item.nm2nd}}
                </v-btn>                
                <v-chip
                  class="ml-1"
                  small
                  :color="setColorStatus(item.cstatCd)"
                  :dark="dark"
                  @click="showItemAction(item, 1)"
                  v-if="item.statNm2 != '' "
                >
                  {{ item.statNm2}}
                </v-chip>
              </div>
            </td> 
            <td class="v-data-table__divider">
              <div class="d-flex align-center">
                <a 
                :dark="dark"
                class="text-decoration-underline"
                @click="subjectShow(item)"
                >{{ item.subject }}</a>
              </div>
            </td>
            <td class="v-data-table__divider text-center">{{ item.regDt }}</td>
            <td class="v-data-table__divider ">{{ item.issueOfcr }}</td>
            <td class="v-data-table__divider ">{{ item.regEmpnoNm }}</td>
            <td class="v-data-table__divider text-center">{{ item.evtNm }}</td>
            <td class="v-data-table__divider ">{{ item.rsnNm }}</td>
          </tr>
        </template> 
      </v-data-table>  
      <!-- For Show Dialog             -->
      <!-- Show Dialog for each Action-->
      <v-dialog
        v-model="dialogAction" 
        scrollable
        persistent
        transition="dialog-bottom-transition"
        width="1000" 
      >              
        <v-card>
          <v-card-title class="cyan darken-1">
            <span class="text-subtitle-2 white--text">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn
              :dark="dark"
              icon
              @click="dialogAction = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
              <v-card-text class="pa-0 bg-white" > 
                <v-data-table
                  :mobile-breakpoint="800"
                  :mobile="mobile"
                  :headers="dialogActionHeaders"
                  :items="dialogActionList"
                  :dense="true"
                  :dark="dark"
                  hide-default-footer
                  :sort-by="[]"
                  :sort-desc="[false]"
                >
                  <template v-slot:item="{ item, isMobile }">    
                    <mobile-card-item
                        v-if="isMobile"
                        :item="item"
                        :header-value="item.rno"
                        :fields="dialogActionHeadersMobileFields"            
                        > 
                    </mobile-card-item>
                    <tr v-else class="custom-pc-row">                         
                      <td class="v-data-table__divider text-center">{{ item.rNo }}</td>
                      <td class="v-data-table__divider text-center">{{ item.dlNm }}</td>
                      <td class="v-data-table__divider text-center">{{ item.issueDt }}</td>
                      <td class="v-data-table__divider text-center">{{ item.cnfmDt }}</td>                     
                      <td class="v-data-table__divider text-center">{{ item.trgtDt }}</td>                     
                      <td class="v-data-table__divider text-center">{{ item.prodStopDt }}</td>                     
                      <td class="v-data-table__divider text-center">{{ item.stopDt }}</td>                     
                      <td class="v-data-table__divider text-center">{{ item.cntDays }}</td>                     
                      
                    </tr>
                  </template>
              </v-data-table>
          </v-card-text>   
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" text font-weight-bold @click="dialogAction = false">
              Close
            </v-btn>
          </v-card-actions>       
        </v-card>
      </v-dialog>
      <!-- Show subject detail -->
      <v-dialog
        v-model="dialogSubject" 
        scrollable
        persistent
        transition="dialog-bottom-transition"
        width="800" 
      >        
        <v-card>
          <v-card-title class="cyan darken-1">
            <span class="text-subtitle-2 white--text">Description</span>
            <v-spacer></v-spacer>
            <v-btn
              :dark="dark"
              icon
              @click="dialogSubject = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
            <v-card >              
              <v-card-text class="text-subtitle-2 black--text font-weight-bold">
                {{ formSubjectTitle }}
              </v-card-text>                
            </v-card>
        </v-card>
      </v-dialog>
      <!-- Show Comment detail -->
      <v-dialog
        v-model="dialogDetail" 
        scrollable
        persistent
      >            
        <v-card dense v-for=" item in gridDetailList" :key="item.rno">
          <v-card-title class="d-flex align-center cyan green darken-3" >
            <v-chip
              class="mr-2"
              color="white"
              outlined
            >
              {{ item.rno }}
            </v-chip>
            <span class="text-subtitle-2 white--text">Detail Comment</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="dialogDetail = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <DxScrollView
              height="100%"
              width="100%">
              <div>                                
                <v-card class="mx-auto" >
                  <div :dark="dark" class="d-flex flex-no-wrap justify-space-between light-green accent-4  darken-2" >
                    <div >
                      <v-card-title>Ship No</v-card-title>
                      <v-card-subtitle>{{ item.shipNo }}</v-card-subtitle>                      
                    </div>
                    <div >
                      <v-card-title>Comment No</v-card-title>
                      <v-card-subtitle >{{ item.issueRefdoc }}</v-card-subtitle>
                    </div>
                  </div>
                  <!-- Show Image Comment -->
                  <v-row class="justify-center">
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      ml="2"
                    >
                    <v-card-text class="pa-0 flex-grow-1">
                      <viewer 
                        :images="[content]" 
                        :options="viewerOptions"
                        class="viewer-container-class"
                      >
                        <img
                          v-if="item.imgNo != null"
                          :src="content" 
                          class="fit-image"
                        />                        
                      </viewer>                      
                    </v-card-text>
                    <div  class="d-flex flex-row mt-1" >
                        <!-- Attach file Design -->
                        <v-btn 
                          v-if="item.cntImgDsn != null"
                          x-small
                          color="primary"
                          :dark="dark"
                          @click="openFileDialog(item, 'R')"
                        >
                          Design file: {{ item.cntImgDsn }}
                        </v-btn>
                        <!-- Attach file QM -->
                        <v-btn 
                          v-if="item.cntImgQm != null"
                          x-small
                          color="primary"
                          :dark="dark"
                          @click="openFileDialog(item, 'C')"
                          class="ml-2"
                        >
                          QM file: {{ item.cntImgQm }}
                        </v-btn>
                        <!-- Attach file Production -->
                        <v-btn 
                          v-if="item.cntImgPro != null"
                          x-small
                          color="primary"
                          :dark="dark"
                          @click="openFileDialog(item, 'A')"
                          class="ml-2"
                        >
                          Prod file: {{ item.cntImgPro }}
                        </v-btn>
                    </div>
                    </v-col>
                  </v-row>
                  <!-- Show Expand Comment content -->
                  <div 
                    dark class="light-green accent-4 " >
                    <v-card-actions 
                      dense 
                      @click="showContentComment = !showContentComment">
                       <span color="primery" text > Subject: {{ item.subject }} </span>
                      <v-spacer></v-spacer>
                      <v-btn dense icon >
                        <v-icon>{{ showContentComment ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </div>  
                  <v-expand-transition >
                    <div v-show="showContentComment">
                      <v-divider></v-divider>

                      <v-card-subtitle class="mt-n1"
                        :style="{'font-size':'10pt'}"
                      >
                        Comment content:
                      </v-card-subtitle>
                      <v-card-title dense class="mt-n3"
                        :style="{'font-size':'10pt', 'font-weight': '300', 'line-height': '1.3rem', 'margin-inline': '5px'}"
                      >
                        {{ item.description }}
                      </v-card-title>
                    </div>
                  </v-expand-transition>
                  <v-divider></v-divider>
                  <!-- End show Image Comment -->  
                  <!-- QM Input Comment                      -->
                  <div dark class="light-green accent-4">
                    <v-card-actions  @click="showQm = !showQm">
                      <span color="primery" text > QM Input Comment </span>
                      <v-spacer></v-spacer>
                      <v-btn icon >
                        <v-icon>{{ showQm ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </div>
                  <v-expand-transition>
                    <div v-show="showQm">
                      <v-divider></v-divider>
                      <template>
                        <v-form >
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.regDt"
                                  label="Input comment date"
                                  dense
                                  readonly
                                  class="no-line"
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.clsNm"
                                  label="Publisher"
                                  dense
                                  readonly
                                  class="no-line"
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.owner"
                                  label="Ship Owner"
                                  dense
                                  readonly
                                  class="no-line"
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.qmPartNm"
                                  label="QM part"
                                  dense
                                  readonly
                                  class="no-line"
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.issueBy"
                                  label="Issue by"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.evtNm"
                                  label="Main event"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.rsnNm"
                                  label="Reason"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.regFull"
                                  label="QM Incharger"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </template>
                    </div>
                  </v-expand-transition>
                  <!-- 1st Action -->
                  <v-divider></v-divider>
                  <div dark class="light-green accent-4">
                    <v-card-actions  @click="show1st = !show1st">
                      <v-btn
                        color="primery"
                        text
                      >
                        1st Action
                      </v-btn>

                      <v-spacer></v-spacer>

                      <v-btn
                        icon
                      >
                        <v-icon>{{ show1st ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </div>
                  <v-expand-transition>
                    <div v-show="show1st">
                      <v-divider></v-divider>
                      <template>
                        <v-form >
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.codeNm"
                                  label="1st Group/section"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.deptNm1"
                                  label="1st Department"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.issueDt"
                                  label="Issue date by QM"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.statNm1"
                                  label="1st Status"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.cnfmDt"
                                  label="1st Confrim date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.replyDt"
                                  label="1st Reply date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.replyEmpnoNm1"
                                  label="1st Reply person"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-card-actions  @click="show1stContent = !show1stContent">
                                  <v-text-field
                                    v-model="item.rplyNm1"
                                    label="1st Reply content"
                                    dense
                                    readonly
                                    flat
                                    solo
                                  ></v-text-field>

                                  <v-spacer></v-spacer>

                                  <v-btn
                                    v-if="item.replyCtnt !=null"
                                    icon
                                  >
                                    <v-icon>{{ show1stContent ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                  </v-btn>
                                </v-card-actions>

                                <v-expand-transition v-if="item.replyCtnt !=null">
                                  <div v-show="show1stContent">
                                    <v-divider></v-divider>

                                    <v-card-text>
                                      Reply content: {{ item.replyCtnt }}
                                    </v-card-text>
                                  </div>
                                </v-expand-transition>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.dlyNm1"
                                  label="1st Reply delay"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.trgtDt"
                                  label="1st target date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </template>
                    </div>
                  </v-expand-transition>
                  <v-divider></v-divider>
                  <div :dark="dark" 
                      class="light-green accent-4" 
                    v-if="item.codeNm2 != null"
                  >
                    <v-card-actions  @click="show2nd = !show2nd">
                      <span color="primery" text > 2nd Action </span>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                      >
                        <v-icon>{{ show2nd ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </div>                  
                  <v-expand-transition v-if="item.codeNm2 != null">
                    <div v-show="show2nd">
                      <v-divider></v-divider>
                      <template>
                        <v-form >
                          <v-container>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.codeNm2"
                                  label="2nd Group/section"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.deptNm2"
                                  label="2nd Department"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.issueDt"
                                  label="Issue date by 2nd dept"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.statNm2"
                                  label="2nd Status"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.cnfmDt2"
                                  label="2nd Confrim date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.replyDt2"
                                  label="2nd Reply date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.replyEmpnoNm2"
                                  label="2nd Reply person"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                              <v-card-actions  @click="show2ndContent = !show2ndContent">
                                  <v-text-field
                                    v-model="item.rplyNm2"
                                    label="2nd Reply content"
                                    dense
                                    readonly
                                    flat
                                    solo
                                  ></v-text-field>                                      
                                  <v-spacer></v-spacer>

                                  <v-btn
                                    icon
                                    v-if="item.replyCtnt2 !=null"
                                  >
                                    <v-icon>{{ show2ndContent ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                  </v-btn>
                                </v-card-actions>

                                <v-expand-transition v-if="item.replyCtnt2 !=null">
                                  <div v-show="show2ndContent">
                                    <v-divider></v-divider>

                                    <v-card-text>
                                      Reply content: {{ item.replyCtnt2 }}
                                    </v-card-text>
                                  </div>
                                </v-expand-transition>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.dlyNm2"
                                  label="2nd Reply delay"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="12"
                                md="4"
                                lg="2"
                              >
                                <v-text-field
                                  v-model="item.trgtDt2"
                                  label="2nd target date"
                                  dense
                                  readonly
                                  
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-form>
                      </template>
                    </div>
                  </v-expand-transition>  
                </v-card>
              </div>              
          </DxScrollView>          
        </v-card>        
      </v-dialog> 
      <!-- Open Attach Files -->
      <v-dialog 
        v-model="dialogFile"                
        scrollable
        persistent
        transition="dialog-bottom-transition"
        top
        width="500"
      >
        <v-card>
          <v-card-title class="cyan darken-1">
            <span class="text-h8 white--text">{{ fileTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn
              :dark="dark"
              icon
              @click="dialogFile = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card >
            <DxScrollView
                height="100%"
                width="100%">
              <v-data-table
                :mobile-breakpoint="800"
                :mobile="mobile" 
                :headers="dialogFileHeaders"
                :items="dialogFileList"
                hide-default-footer
                :sort-by="[]"
                :sort-desc="[false]"
                dense
                :dark="dark"
              >
                <template #[`item.rno`]="{ item }">
                  <v-chip
                    small
                    :color="getColor(item.rno)"
                    :dark="dark"
                  >
                    {{ item.rno }}
                  </v-chip>
                </template>

                <!-- Open file -->
                <template v-slot:[`item.openFile`]="{ item }">             
                  <v-chip
                    small
                    :color="getColor(item.rno)"
                    :dark="dark"
                    @click="fileOpen(item)"
                  >
                  Open file
                  </v-chip>
                </template>
              </v-data-table> 
            </DxScrollView>   
            </v-card>              
        </v-card>              
      </v-dialog> 
      <!-- Show images here -->
      <v-dialog v-model="dialogShowFile" fullscreen persistent>
        <v-card class="d-flex flex-column" style="background: #212121;">
          <v-card-title class="cyan darken-1 white--text py-2">
            <span class="text-subtitle-2">{{ titleFileName }}</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogShowFile = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-0 flex-grow-1" style="height: calc(100vh - 48px); ">
            <viewer 
              :images="[content1]" 
              :options="viewerOptions"
              class="viewer-container-class"
            >
              <img 
                :src="content1" 
                class="fit-image"
              />
            </viewer>
          </v-card-text>
        </v-card>
      </v-dialog>                
    </v-card>
    <v-btn
      v-scroll="onScroll"
      v-show="fab && isMobileDevice"
      fab
      dark="dark"
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      style="z-index: 1000;"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>  
</template>

<script>
  import  {
          mdiAccount,
          mdiPencil,
          mdiShareVariant,
          mdiDelete,
          mdiSelectSearch,
          mdiMapSearch 

        } from '@mdi/js'

  import  { getShipList, 
            getQMPartList,
            getSecCommentList,
            getQmEmployeeList,
            getTelephoneList,
            getEventList,
            getDivList,
            getPublisherList,
        } from '@/api/view/tqm/80/v80comm.js'

  import  {
          v80d1010List,
          v80d1010DetailList,
          v80d1010DetailFileList
        } from '@/api/view/tqm/80/v80d1010.js'

  import DxDateBox from 'devextreme-vue/date-box'
  import baseview from '@/components/base/baseview.vue' // base page addition
  import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
  import { mobileTableMixin } from '@/mixins/mobileTableMixin.js' // Import mixin mới
  import EventBus from '@/components/event-bus';
  
  import { DxScrollView } from "devextreme-vue/scroll-view";
  import { ftpDownload} from '@/api/view/tqm/common/common.js'
  import {ftpDownloadViewer} from "@/api/view/tqm/common/common.js";

  import {
  getDateFormat,
  } from '@/utils/common.js'

  import dayjs from 'dayjs';

export default {
  name: "v80d1010",
  mixins: [baseview, BaseDataGrid, mobileTableMixin],
  components: {
    DxDateBox,
    DxScrollView,
    // AppButton,
  },
  data: () => ({
    Path : '',
    content:'',
    content1:'',
    showpdf: false,
    showpdf1: false,
    dark: false,
    isMobileDevice: false, // Biến mới
    fab: false,
    icons: {
      mdiAccount,
      mdiPencil,
      mdiShareVariant,
      mdiDelete,
      mdiSelectSearch,
      mdiMapSearch

    },
    // Popup
    makePop: false,
    // tooltip 
    subjectTitle:'',
    // Dialog
    dialogAction: false,
    dialogSubject: false,
    dialogDetail: false,
    dialogShowFile: false,
    titleFileName:'',
    editedIndex: -1,
    dialogActionList: [],
    titleActionDeptName:'',
    dialogDetailInputList:[],
    // Test Expansion panels
    panel: [0, 1, 2],
    readonly: false,
    showContentComment: true,
    showQm: true,
    show1st: true,
    show2nd: true,
    show1stContent: false,
    show2ndContent:false,
    //File detail
    dialogFile: false,
    fileTitle:'',
    dialogFileHeaders: [
                      { text: 'No', align: 'center', value: 'rno', sortable: false, },
                      { text: 'File No', sortable: false, divider: true, align: 'center', value: 'imgNo',  },
                      { text: 'File type', sortable: false, divider: true, align: 'center', value: 'imgExt',  },
                      { text: 'Control file', sortable: false, divider: true, align: 'center', value: 'openFile',  },

    ],
    dialogFileList: [],
    //Detail
    dialogDetailInputHeaders:[],
    dialogActionHeaders: [
                { text: 'No', align: 'center', sortable: false, value: 'rno', divider: true, },
                { text: 'Delay name', align: 'center', sortable: false, value: 'dlNm', divider: true, },
                { text: 'Issue date', sortable: false, divider: true, align: 'center',value: 'issueDt', },
                { text: 'Close date', sortable: false, divider: true, align: 'center',value: 'cnfmDt', },
                { text: 'Target date', sortable: false, divider: true, align: 'center',value: 'trgtDt', },
                { text: 'Pro stop date', sortable: false, divider: true, align: 'center',value: 'prodStopDt', },
                { text: 'QM stop date', sortable: false, divider: true, align: 'center',value: 'stopDt', },
                { text: 'Count days', sortable: false, divider: true, align: 'center',value: 'cntDays', },
              
              ],
    dialogActionHeadersMobileFields: [
      // { label: 'No', key: 'rno' },
      { label: 'Delay name', key: 'dlNm' },
      { label: 'Issue date', key: 'issueDt' },
      { label: 'Close date', key: 'cnfmDt' },
      { label: 'Target date', key: 'trgtDt' },
      { label: 'Pro stop date', key: 'prodStopDt' },
      { label: 'QM stop date', key: 'stopDt' },
      { label: 'Count days', key: 'cntDays' },

    ],                

    stDate: '',
    edDate: '',
    shipNoList: [],
    shipNo: '',

    deptName: '',
    deptNameList: [],
    deptCd: '',
    sectCd: '',

    respClsName: '',
    respClsNameList: [],
    respCls: '',

    clsCd: '',
    publisherName:'',
    publisherNameList: [],

    empNo: '',
    empName: '',
    empNameList: [],

  
    panel: [0],
    disabled: false,
    hover: true,

    // data
    gridMainList: [],
    listSize: 0,
    gridDetailList: [],
    gridDetailFileList: [],
    
    mobile: true,
    search: '', 
    hide2ndAction: false,
    headers: [
                { text: 'No', sortable: false, align: 'center', value: 'details', divider: true,  },
                { text: 'Ship No', sortable: false, divider: true, align: 'center',value: 'shipNo', },
                { text: 'Status', sortable: false, divider: true, align: 'center',value: 'statNm', },
                { text: 'Comment No', sortable: false, divider: true, align: 'center',value: 'issueRefDoc', },
                { text: '1st Action', sortable: false, divider: true, align: 'center',value: 'action1', visible: 'true'  },
                { text: '2nd Action', sortable: false, divider: true, align: 'center',value: 'action2', visible: 'true' },
                { text: 'Subject', sortable: false, divider: true,align: 'center',value: 'subject',  },
                { text: 'Input Comment', sortable: false, divider: true,align: 'center',value: 'regDt',  },
                { text: 'Issue by', sortable: false, divider: true,align: 'center',value: 'issueOfcr',  },
                { text: 'QM PIC', sortable: false, divider: true,align: 'center',value: 'regEmpnoNm',  },
                { text: 'Main event', sortable: false, divider: true,align: 'center',value: 'evtNm',  },
                { text: 'Reason', sortable: false, divider: true,align: 'center',value: 'rsnNm',  },
              ],
    selectedRowIndex: null, // Lưu index của dòng đang được chọn 
    // Chỉ cần khai báo list này là giao diện tự sinh ra
    mobileFields: [
      { label: 'Action', key: 'details' },
      { label: 'Ship No', key: 'shipNo' },
      { label: 'Status', key: 'statNm' },
      { label: 'Comment No', key: 'issueRefDoc' },
      { label: '1st Action', key: 'action1' },
      { label: '2nd Actiont', key: 'action2' },
      { label: 'Subject', key: 'subject' },
      { label: 'Input Comment', key: 'regDt' },
      { label: 'Issue by', key: 'issueOfcr' },
      { label: 'QM PIC', key: 'regEmpnoNm' },
      { label: 'Main event', key: 'evtNm' },
      { label: 'Reason', key: 'rsnNm' },

    ],                        
      
    statCd1:true,
    statCd3:true,
    statCd5:true,
    statCd6:true,
    statCd7:true,
    statCd8:true,
    statCd9:false,
    statCdCan:false,    
    viewerOptions: {
      toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: 4,
        prev: 0, // Ẩn nút nếu chỉ có 1 ảnh
        play: { show: 4, size: 'large' },
        next: 0,
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4,
      },
      inline: false,
      button: true,
      navbar: false, // Ẩn thanh danh sách ảnh bên dưới nếu chỉ xem 1 tấm
      title: false,
      tooltip: true,
      movable: true, // Cho phép kéo ảnh
      zoomable: true, // Cho phép zoom
      rotatable: true, // Cho phép xoay
      scalable: true, // Cho phép lật (mirror)    
      transition: true,
      fullscreen: true,
      keyboard: true,  
      viewed() {
        this.viewer.zoomTo(1); // Reset về tỉ lệ thực của ảnh hoặc...
        this.viewer.scale(1); // -1 Nếu cần lật ảnh
      },
    }
  }),
  computed: {
    formTitle () {
          return this.editedIndex === -1 ? '1st Action: '  + this.titleActionDeptName : '2nd Action: ' + this.titleActionDeptName
        },

    formSubjectTitle (){
      return this.subjectTitle
        } ,  
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },
  created() {
    EventBus.$on(this.$options.name + "_search", () => { 
      this.btnRetrieve();
    });
  },
  mounted() {
    this.init()
    //Apply for Fab
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);

    this.loadColumnWidths(); // Khôi phục ngay khi load trang
    
    // Lắng nghe sự kiện thả chuột để lưu lại kích thước mới
    this.$el.querySelector('.v-data-table').addEventListener('mouseup', () => {
      // Đợi một chút để trình duyệt cập nhật xong style.width
      setTimeout(() => {
        this.saveColumnWidths();
      }, 100);
    });
  
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    EventBus.$off(this.$options.name + "_search");
  },
  methods: {            
      btnRetrieve() {
          this.gridMainList = []        
          this.getMainList()          
      },
      getStrFormat(date) {
        return getDateFormat(date)
      },
      init() {
        let toDay = new Date      
        this.stDate = toDay.setDate(toDay.getDate() - 1);
        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate() + 1);

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')
        this.getList()

      },    
      //getList
      async getList() {
        try {
            this.openLoading('searching')
            let params = {
              cdDiv: '',
              respCd: '21%'
            }
            // Department Division
            await getDivList(params).then(res => {
              this.respClsNameList.push('All')
              res.list.forEach(e => {
                this.respClsNameList.push(e.respCls + ' : ' + e.respClsNm)
              });
              this.respClsName = this.respClsNameList[0]
            })
            // getShipList
            await getShipList(params).then(res => {
                    this.shipNoList.push('All')
                    res.list.forEach(e => {
                      this.shipNoList.push(e.shipNo)
                    });
                    this.shipNo = this.shipNoList[0]
                  })
            // Section Department
            await getSecCommentList(params).then(res => {
                    this.deptNameList.push('All')
                    res.list.forEach(e => {
                      this.deptNameList.push(e.sectCd + ' : ' + e.sectNm)
                    });
                    this.deptName = this.deptNameList[0]
                  })         

            // Publisher
            await getPublisherList(params).then(res => {
              this.publisherNameList.push('All')
              res.list.forEach(e => {
                this.publisherNameList.push(e.clsCd + ' : ' + e.clsNm)
              });
              this.publisherName = this.publisherNameList[0]
            })

            // QM PIC List
            await getQmEmployeeList(params).then(res => {
              this.empNameList.push('All')
              res.list.forEach(e => {
                this.empNameList.push(e.empNo + ' : ' + e.empNm)
              });
              this.empName = this.empNameList[0]
            })
            


            } finally {

                this.endLoading()
            }

      },
      async getMainList() {
          try {
              this.openLoading('searching') 
              
              this.respCls = this.respClsName.split(' : ')[0]
              this.clsCd = this.publisherName.split(' : ')[0]  
              this.sectCd = this.deptName.split(' : ')[0]
              this.empNo  = this.empName.split(' : ')[0]
              let params = {
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                clsCd: this.clsCd ==='All' ? '' : this.clsCd,
                respCls: this.respCls === 'All' ? '' : this.respCls,
                sectCd: this.sectCd === 'All' ? '%' : this.sectCd,
                deptCd:  this.sectCd === 'All' ? '' : this.sectCd.substring(0,2),
                statCd1: this.statCd1 === true ? '1' : '',
                statCd3: this.statCd3 === true ? '3' : '',
                statCd5: this.statCd5 === true ? '5' : '',
                statCd6: this.statCd7 == true ? '6' : '',
                statCd7: this.statCd7 == true ? '7' : '',
                statCd8: this.statCd5 === true ? '8' : '',
                statCd9: this.statCd9 == true ? '9' : '',
                statCdCan: this.statCdCan === true ? 'C' : '',
                stDate: this.stDate,
                edDate: this.edDate,
                empNo: this.empNo === 'All' ? '' : this.empNo

              }
              await v80d1010List(params).then(res => {
                let list = []
                let cnt = 1;
                  res.list.forEach(e => {
                    // e.shipNo,e.clsCd,e.cmtSeq,e.statCd,e.subject ,e.issueOfcr, e.issueDt,e.issueDt1,e.passday, e.regEmpno,e.regDt,e.deptCd,e.rsnCd, e.description,
                    // e.codeNm,e.nm1st,e.replyCtnt1,e.replyCtnt2,e.rrespCd, e.rstatCd, e.rchkDt, e.crespCd,e.cstatCd,e.cchkDt,e.respChgReq, e.rcnfmDt,e.ccnfmDt,
                    // e.rregDt,e.cregDt,e.dlCd,e.dlCd1,e.prodStopdt,e.prodStopdt1,e.stopDt, e.stopDt1,e.matDt,e.matDt1,e.cntDays,e.cntDays1,e.cnfmDt,e.cnfmOfcr,
                    // e.issueRefDoc,e.rremark,e.cremark,e.ord,e.importantYn,e.qmPart, e.hvsYn,e.block,e.matlDly,e.trgtDt,e.trgtDt2,e.cprodYn,e.rprodYn,e.cmatYn,
                    // e.rmatYn,e.cnf2Yn,e.qmGrp, e.dlyDay,e.mevt,e.evtNm,e.statNm,e.statNm1,e.rsnNm,e.regEmpnoNm,e.dlNm,e.dlNm1,
                    list.push({
                      ...e,
                      rno: cnt++,
                      nm2nd: e.nm2nd === null ? '' : e.nm2nd,
                      statNm2: e.statNm2===null ?'': e.statNm2,
                    })
                    
                  });

                  this.gridMainList = list
                  this.listSize = this.gridMainList.length;

                  if (this.listSize > 0 && this.isMobileDevice) {
                    this.panel = [];
                  }
              })

          } finally {
              this.endLoading()
          }
      },

      async getDetailList(obj) {
          try {
              this.openLoading('searching') 
              let params = {
                shipNo: obj.shipNo,
                clsCd: obj.clsCd,
                cmtSeq: obj.cmtSeq,
              }  
              await v80d1010DetailList(params).then(res => {
                let list = []
                  res.list.forEach(e => {
                    // Show file JPG
                    if(e.imgNo != null){
                      this.Path = 'attachfile/QC/COMMENT/'+ e.imgNo + '.' + e.imgExt;
                      var dirs = this.Path.split('/');    
                      var t1 =  dirs[dirs.length - 1];
                      var fname = t1.split('.');
                      var extend = fname[1];
                      var datatype = "";
                      fname = fname[0].replace(/ /g, "")
                      if(extend.toUpperCase() === 'PDF'){
                        datatype = "data:application/pdf;base64,";
                        this.showpdf = true;
                      }
                      else{
                        datatype = "data:image/" + extend + ";base64,";
                        this.showpdf = false;
                      }
                      ftpDownloadViewer(this.Path, fname).then((res) =>{        
                        this.content = datatype + res.body;
                      }).catch(error => {
                        alert('This file is not existed. Please contact HVS PIC!');
                      })
                      .finally(() => {
                      })
                    }                   
                    // e.shipNo,e.clsCd,e.clsNm,e.cmtSeq,e.rsnCd,e.rsnNm,e.issueCls,e.complyCd,e.wkKind,e.stgCd,e.block, e.issueDt,e.cmtYn, e.issueDt2,e.regDt,e.cnfmDt,
                    // e.cnfmDt2,e.qmCnfmDt,e.qmCnfmDt2, e.prodStopDt1,e.prodStopDt2,e.prodStopEmp1,e.prodStopEmp2,e.matArrDt1,e.matArrDt2,e.matArrEmp1,e.matArrEmp2,
                    // e.delayStopDte1,e.delayStopDte2,e.delayArriDte1,e.delayArriDte2,e.regEmpno,e.regEmpnoNm, e.tel,e.issueOfcr,e.cnfmOfcr, e.cnfmOfcr2,e.ncrCode,
                    // e.issueRefdoc,e.issueRefinfo,e.location,e.subject,e.description,e.suggestion, e.seriesYn,e.cmtnoCd,e.issueDoc3,e.drawNo,e.ownsDocno,e.issueBy,
                    // e.importantYn,e.imgNo,e.fileName,e.imgExt,e.showImg,e.dwgFile,e.replyEmpno,e.replyEmpnoNm1,e.replyEmpno2,e.replyEmpnoNm2,e.respCls,e.gbanCd,
                    // e.gbanCd2,e.respCd,e.deptNm1,e.respCd2,e.deptNm2, e.jumuYn,e.jumuYn2,e.statCd,e.statNm1,e.statCd2,e.statNm2,e.respchgReq,e.replyDt,e.replyDt2,
                    // e.replyCtnt,e.replyCtnt2,e.remark,e.remark2,e.codeNm,e.codeNm2,e.deptSect1,e.deptSect2,e.recvDt,e.acptYn,e.replyTel,e.chkEmpno,e.chkDt,e.matlDly,
                    // e.matlDly,e.matrDate,e.qmPart,e.qmPartNm,e.hvsYn,e.qmYn,e.haveYn,e.chkYn,e.dsnYn,e.cmtnoDoc1,e.cmtnoDoc2,e.trgtDt,e.trgtDt2,e.mainSta,e.dlyCd1,e.dlyNm1,
                    // e.dlyCd2,e.dlyNm2,e.rplyCd1, e.rplyNm1,e.rplyCd2,e.rplyNm2,e.owner,e.prodDiv1st,e.hotWk,e.majYn,e.weekYn,e.prodYn1,e.prodYn2,e.matArrYn1, e.matArrYn2,
                    // e.qmApprStopStat1, e.qmApprStopStat2,e.evtNm,e.stopRsnCd,e.stopRsnNm,e.stopRsnCd2,e.stopRsnNm2,e.qmApprStopDte1,e.qmApprStopDte2,e.porNo,e.msys,e.lsys,
                    // e.ssys,e.mevt,e.cntImgDsn,e.cntImgQm,e.cntImgPro,
                    list.push({
                      ...e,
                      rno: obj.rno,
                      regFull: e.regEmpno + ': ' + e.regEmpnoNm, 
                    })
                    
                  });
                  this.gridDetailList = list
              })

          } finally {
              this.endLoading()
          }
      },
    
    //File list
    async initialize (obj, div) {
        try {
              this.openLoading('searching') 
              let params = {                
                  shipNo: obj.shipNo,
                  clsCd: obj.clsCd,
                  cmtSeq: obj.cmtSeq,
                  div: div
              }
              await v80d1010DetailFileList(params).then(res => {
                let list = []
                let cnt = 1
                  res.list.forEach(e => {
                    //e.imgNo,e.fileName,e.imgExt,e.div
                    list.push({
                      ...e,
                      rno: cnt++,
                    })                    
                  });

                  this.dialogFileList = list
              })

          } finally {
              this.endLoading()
          }
      
    },
    getColor (value) {
        if (value > 40) return 'red'
        else if (value > 20) return 'orange'
        else return 'green'
    },  
    setColorStatus (str) {
        if (str === '1') return 'red'
        else if (str === '3') return 'indigo'
        else if (str === '5'||str === '8') return 'green darken-1'
        else if (str === '6'||str === '7') return 'blue'
        else if (str === '9') return 'amber'
        else return 'orange'
    },  
    showItemAction(e, index){
      this.editedIndex = index
      if(index === -1){
        this.titleActionDeptName = e.nm1st
        this.dialogActionList = [{rno: 1, dlNm: e.dlNm, issueDt: e.issueDt,  cnfmDt: e.rcnfmDt,   trgtDt: e.trgtDt,  prodStopDt: e.prodStopdt,   stopDt:e.stopDt,  cntDays: e.cntDays},]
      }else{
        this.titleActionDeptName = (e.nm2nd === null ? '' : e.nm2nd)
        this.dialogActionList = [{rno: 1, dlNm: e.dlNm1, issueDt: e.issueDt1, cnfmDt: e.ccnfmDt, trgtDt: e.trgtDt2,  prodStopDt: e.prodStopdt1,  stopDt: e.stopDt1,  cntDays: e.cntDays1},]
      }
      this.dialogAction = true
    },

    subjectShow(e){
      this.subjectTitle = (e.description === null ? '' : e.description)   
      this.dialogSubject = true
    },

    showDetailComment(e){
      this.getDetailList(e)
      this.showQm = true
      this.show1st = true
      this.show2nd = true
      this.dialogDetail = true 
      this.showContentComment = true 
    },

    //openFileDialog
    openFileDialog (item, div) {
      if(div==='R'){
        this.fileTitle = 'Design attach file'
      }else if(div==='A'){
        this.fileTitle = 'Production attach file'
      }      
      else{
        this.fileTitle = 'QM attach file'
      }
      if(item.cntImgDsn > 0 || item.cntImgQm > 0 || item.cntImgPro > 0){
        this.initialize(item, div)
        this.dialogFile = true
      }else{
        this.vToastify(this.$t('Sorry!, No attach file!'), 'warn')
        this.dialogFile = false
      }
    },

    fileOpen(e){
        this.dialogShowFile = true
        this.titleFileName = e.imgNo + '.' + e.imgExt;
        let dirPath = 'attachfile/QC/COMMENT/';
        let fileType = e.imgExt;
        let filePath = dirPath + e.imgNo + '.' + fileType;

        var dirs = fileType.split('/');    
        var t1 =  dirs[dirs.length - 1];
        var fname = t1.split('.');
        var datatype = "";
        fname = fname[0].replace(/ /g, "")
        if(fileType.toUpperCase() ==='PDF'){
          datatype = "data:application/pdf;base64,";
          this.showpdf1 = true;
          this.openLoading('searching')
          ftpDownload(filePath, e.imgNo)
          .finally(() => {
            this.endLoading()
          })          
        }else{
          datatype = "data:image/" + fileType + ";base64,";
          this.showpdf1 = false;

          this.openLoading('searching')
          ftpDownloadViewer(filePath, fname).then((res) =>{
            this.content1 = datatype + res.body;
          }).catch(error => {
            alert('This file is not existed. Please contact HVS PIC!');
          })
          .finally(() => {
            this.endLoading()
          })
        } 
    },

    // Hàm lưu độ rộng vào localStorage
    saveColumnWidths() {
      const widths = {};
      const ths = this.$el.querySelectorAll('.v-data-table th');      
      ths.forEach((th, index) => {
        // Lưu theo index hoặc value của header để không bị lẫn
        widths[index] = th.style.width;
      });
      
      localStorage.setItem(`table_width_${this.$options.name}`, JSON.stringify(widths));
    },

    // Hàm khôi phục độ rộng khi vào lại trang
    loadColumnWidths() {
      const savedWidths = localStorage.getItem(`table_width_${this.$options.name}`);
      if (savedWidths) {
        const widths = JSON.parse(savedWidths);
        this.$nextTick(() => {
          const ths = this.$el.querySelectorAll('.v-data-table th');
          ths.forEach((th, index) => {
            if (widths[index]) {
              th.style.width = widths[index];
            }
          });
        });
      }
    },

  },

};
</script>
<style>
/* Import file CSS dùng chung cho toàn bộ Mobile Card */
/* Sử dụng dấu ~ trước @ để Webpack nhận diện đúng alias */
@import "~@/assets/css/mobile-table.css";

/* Các CSS tùy chỉnh khác cho menu này */
.border-bottom {
  border-bottom: 1px dashed #eee;
}
.v-card__text {
  max-height: 70vh; /* Giới hạn chiều cao popup trên mobile */
}

.custom-pc-row td .v-image__image {
  background-size: contain !important; /* Đảm bảo ảnh vẽ kỹ thuật luôn thấy hết chi tiết */
}

/* Trong mobile-table.css hoặc style của v80w1010.vue */
.cursor-pointer {
  cursor: zoom-in !important; /* Đổi icon chuột thành hình kính lúp */
  transition: opacity 0.3s;
}

.cursor-pointer:hover {
  opacity: 0.8; /* Hiệu ứng mờ nhẹ khi di chuột qua */
}

/* Hiệu ứng cho icon kẹp giấy */
.pdf-icon-btn {
  transition: all 0.2s ease-in-out; /* Giúp hiệu ứng mượt mà hơn */
  cursor: pointer;
}

/* Khi di chuột vào trên PC */
.pdf-icon-btn:hover {
  transform: scale(2); /* Phóng to 30% */
  color: #d32f2f !important; /* Đổi sang màu đỏ đậm hơn (v-red-darken-2) */
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.2)); /* Thêm bóng đổ nhẹ */
}

/* Hiệu ứng khi nhấn vào (Active) */
.pdf-icon-btn:active {
  transform: scale(1.1);
  opacity: 0.7;
}

/* Thu hẹp khoảng cách giữa checkbox và label trong Vuetify 2 */
.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 1px !important; 
}

/* Tùy chỉnh màu label cho đậm nét hơn trên mobile nếu cần */
.v-input--selection-controls .v-label {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.87) !important;
}

/* CSS để đảm bảo chữ hiển thị đen đậm, dễ đọc */
.black-input :deep(input) {
  color: rgba(0, 0, 0, 0.87) !important;
}

/* Ép viewer container chiếm toàn bộ diện tích */
.viewer-container-class {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* Nền đen để nổi bật ảnh */
}

/* Ép hình ảnh hiển thị trọn vẹn */
.fit-image {
  max-width: 100% !important;
  max-height: 100% !important;
  width: auto !important;
  height: auto !important;
  object-fit: contain !important; /* Đảm bảo không bị chém */
  display: block;
}
</style>